import React from "react";
import { Form, Row, Col } from "react-bootstrap";

import "./Forms.css";
import InputError from "../../InputError/InputError";

function NumberInputV2({
  required = false,
  type,
  formLabel,
  size,
  placeholder,
  name,
  value,
  onChange,
  isError,
  disabled,
  errorMessage = "",
}) {
  
  const handleKeyDown = (e) => {
    const allowedKeys = [
      "Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Home", "End"
    ];
    const isNumber = /^[0-9]$/.test(e.key);
    const isDot = e.key === ".";
    const alreadyHasDot = e.currentTarget.value.includes(".");

    if (
      !isNumber &&
      !allowedKeys.includes(e.key) &&
      !(isDot && !alreadyHasDot)
    ) {
      e.preventDefault();
    }
  };

  return (
    <Form>
      {type === "inline" ? (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Row>
            <Col sm={4}>
              <Form.Label className="form-label align-left">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            </Col>
            <Col sm={6}>
              <Form.Control
                type="text"
                placeholder={placeholder}
                size={size}
                name={name}
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDown}
                disabled={disabled}
              />
              <InputError
                isValid={isError}
                message={
                  errorMessage !== "" ? errorMessage : "This field is required"
                }
              />
            </Col>
          </Row>
        </Form.Group>
      ) : (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="align-left form-label">
            {formLabel}
            {required && <span className="badge">*</span>}
          </Form.Label>
          <Form.Control
            type="text"
            placeholder={placeholder}
            size={size}
            name={name}
            value={value}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            disabled={disabled}
          />
          <InputError
            isValid={isError}
            message={
              errorMessage !== "" ? errorMessage : "This field is required"
            }
          />
        </Form.Group>
      )}
    </Form>
  );
}

export default NumberInputV2;
